export default __webpack_public_path__ + "static/media/ALUMNI2.f15a03a6.jpg";